import { NavLink, Outlet } from 'react-router-dom'
import { FilePenLine } from 'lucide-react'
import { cn } from '@/utils/cn'
import { paths } from '@/config/paths'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { PageLayout } from './pageLayout'

const sidebarNavItems = [
  {
    title: 'Custom properties',
    href: paths.admin.settings.customProperties.getHref(),
    Icon: FilePenLine,
    isDisabled: false,
  },
]

const SettingsLayout = () => {
  return (
    <PageLayout title="Settings" path={[{ title: 'Settings' }]}>
      <Card className="grid grid-cols-12 gap-4 p-6">
        <CardHeader className="col-span-12 xl:col-span-3 2xl:col-span-2 p-0">
          <nav className="flex flex-row xl:flex-col gap-2">
            {sidebarNavItems.map((navItem) => (
              <NavLink to={navItem.href} key={navItem.href} className={cn(navItem.isDisabled && 'pointer-events-none')}>
                {({ isActive }) => (
                  <Button variant={isActive ? 'primary' : 'ghost'} disabled={navItem.isDisabled}>
                    {navItem.Icon && <navItem.Icon />}
                    {navItem.title}
                  </Button>
                )}
              </NavLink>
            ))}
          </nav>
        </CardHeader>
        <CardContent className="col-span-12 xl:col-span-9 2xl:col-span-10 p-0">
          <Outlet />
        </CardContent>
      </Card>
    </PageLayout>
  )
}

export default SettingsLayout
